module.exports = __webpack_public_path__ + "img/04.3097351e.png";